var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"navbarbtn",attrs:{"type":"primary","icon":"sys sys-export"},on:{"click":_vm.exportMD}},[_vm._v(" 导 出")])}
var staticRenderFns = []

export { render, staticRenderFns }